import { FC } from "react";
import { Input, Button, Empty } from "antd";
import { Send } from "lucide-react";
import { EstimateTicket } from "~/types/estimate";

const { TextArea } = Input;

interface NotesTabProps {
  estimate?: EstimateTicket;
}

export const NotesTab: FC<NotesTabProps> = ({ estimate }) => {
  if (!estimate) return null;

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Estimate Notes</h2>

      {/* Add Note Form */}
      <div className="border rounded p-4 bg-gray-50">
        <TextArea
          placeholder="Add a note about this estimate..."
          rows={4}
          className="mb-3"
        />
        <Button type="primary" icon={<Send size={16} />}>
          Add Note
        </Button>
      </div>

      {/* Notes List */}
      <Empty
        description="No notes yet"
        className="my-8"
      />
    </div>
  );
};
